<template>
  <v-sheet class="project-wrapper pa-2" :elevation="1">
    <div class="d-block">
      <span class="primary--text" style="font-size: .875rem"
        >{{ $t('presentedForProject') }}:</span
      >
    </div>

    <div class="d-flex">
      <!-- Project Image   -->
      <div
        @click="viewProject"
        style="height: 60px; width: 60px; min-height: 60px; min-width: 60px; "
        class="mr-2 cursor-pointer"
      >
        <base-image
          type="p"
          image-type="t"
          :file-name="project.logo"
          :project-id="projectId"
          :contain="false"
          :imageAlt="projectName"
          style="border-radius: 5px;"
        >
          <template v-slot:loadError>
            <v-sheet :color="project.colors.bg" height="100%" width="100%">
              <v-row
                align="center"
                justify="center"
                style="height : 100%"
                class="ma-0 pa-0"
              >
                <h4
                  :style="{
                    color: project.colors.text
                  }"
                >
                  {{ projectName[0] }}
                </h4>
              </v-row>
            </v-sheet>
          </template>
        </base-image>
      </div>

      <div style="min-height: 60px; width:100%">
        <!-- Project Name -->
        <div class="d-block " style="min-height: 30px; width:100%">
          <span
            @click="viewProject"
            style="font-weight: bold;"
            class="cursor-pointer"
            >{{ projectName }}</span
          >
        </div>

        <!-- Project Actions -->
        <div class="d-block">
          <div class="d-flex">
            <share-menu
              :show="showProjectShare"
              @close="showProjectShare = false"
              entity="PROJECT"
              class="mr-2"
              :entity-id="projectId"
              :title="projectName"
              :projectHashtags="projectHashtags"
            >
              <template v-slot:activator>
                <v-btn
                  @click="showProjectShare = true"
                  depressed
                  fab
                  x-small
                  color="primary"
                  :max-height="btnSize"
                  :max-width="btnSize"
                >
                  <v-icon
                    class="white--text"
                    :small="$vuetify.breakpoint.mdAndUp"
                    :x-small="$vuetify.breakpoint.smAndDown"
                  >
                    {{ icons.mdiShareVariant }}
                  </v-icon>
                </v-btn>
              </template>
            </share-menu>

            <v-btn
              v-if="projectLeaderEmail"
              class="mr-2"
              :href="`mailto:${projectLeaderEmail}`"
              x-small
              fab
              depressed
              color="primary"
              :max-height="btnSize"
              :max-width="btnSize"
            >
              <v-icon
                color="white"
                :small="$vuetify.breakpoint.mdAndUp"
                :x-small="$vuetify.breakpoint.smAndDown"
                >{{ icons.mdiEmail }}</v-icon
              >
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { TemplateArrayHelpers } from '@/utilities/mixins/TemplateArrayHelpers';
import BaseImage from '@/components/base_components/BaseImage/BaseImage.vue';
import ShareMenu from '@/components/base_components/ShareMenu/ShareMenu.vue';
import { mdiShareVariant, mdiEmail } from '@mdi/js';

export default {
  components: {
    BaseImage,
    ShareMenu
  },

  props: {
    project: {
      type: Object,
      required: true
    },

    projectLeaderEmail: {
      type: String,
      required: true
    },

    projectHashtags: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    showProjectShare: false
  }),

  mixins: [TemplateArrayHelpers],

  methods: {
    viewProject() {
      this.$router.push(
        `/view-projects/${this.projectId}/${this.defaultLanguage}`
      );
    }
  },

  computed: {
    ...mapState({
      defaultLanguage: state => state.defaultLanguage
    }),

    btnSize() {
      if (this.$vuetify.breakPointmdAndUp) return 28;
      return 24;
    },

    projectId() {
      return this.project.projectId.replace('#', '');
    },

    projectName() {
      if (!this.project) return '';

      const projectLang = this.project.defaultLanguage;
      if (!this.project?.template) {
        return typeof this.project.name === 'string'
          ? this.project.name
          : this.findTranslationMultipleOptions(
              this.project.name,
              projectLang,
              this.defaultLanguage
            );
      }

      return this.findTranslationMultipleOptions(
        this.project.template[0].name,
        projectLang,
        this.defaultLanguage
      );
    },

    icons: () => ({
      mdiShareVariant,
      mdiEmail
    })
  }
};
</script>

<style scoped>
.project-wrapper {
  width: 100%;
  min-height: 100px;
  background-color: #f6f8fa;
  border-radius: 5px;
}
</style>
